import { SubscriptionEvent } from 'nekst-api';

export function useSubscriptionEventHelper() {
  const getLabel = (type: SubscriptionEvent) => {
    const map = {
      [SubscriptionEvent.TRANSACTION_LAUNCHED]: 'Transaction Launched',
      [SubscriptionEvent.TRANSACTION_UPDATED]: 'Transaction Updated',
      [SubscriptionEvent.CONTACT_CREATED]: 'Contact Created',
      [SubscriptionEvent.CONTACT_UPDATED]: 'Contact Updated',
      [SubscriptionEvent.CONTACT_DELETED]: 'Contact Deleted',

      [SubscriptionEvent.EMAIL_SENT]: 'Email Message Sent',
      [SubscriptionEvent.SMS_SENT]: 'SMS Message Sent',

      [SubscriptionEvent.TRANSACTION_NOTE_CREATED]: 'Transaction Note Created',
      [SubscriptionEvent.TRANSACTION_NOTE_UPDATED]: 'Transaction Note Updated',
      [SubscriptionEvent.TRANSACTION_NOTE_DELETED]: 'Transaction Note Deleted',

      [SubscriptionEvent.TRANSACTION_STATUS_UPDATED]: 'Transaction Status Updated',
      [SubscriptionEvent.TRANSACTION_TYPE_UPDATED]: 'Transaction Type Updated',

      [SubscriptionEvent.TRANSACTION_ASSIGNMENT_CREATED]: 'Transaction Assignment Created',
      [SubscriptionEvent.TRANSACTION_ASSIGNMENT_DELETED]: 'Transaction Assignment Deleted',

      [SubscriptionEvent.CONTACT_NOTE_CREATED]: 'Contact Note Created',
      [SubscriptionEvent.CONTACT_NOTE_UPDATED]: 'Contact Note Updated',
      [SubscriptionEvent.CONTACT_NOTE_DELETED]: 'Contact Note Deleted',
    };

    return map[type];
  };

  return {
    getLabel,
  };
}
